import { colors } from '../colors';
var MuiInputLabel = {
  styleOverrides: {
    root: {
      '&.MuiInputLabel-formControl': {
        color: colors.Neutros60
      }
    }
  }
};
export default {
  MuiInputLabel: MuiInputLabel
};